export const environment = {
  appVersion: '1.0-20250522.141135.343',
  version: require('../../package.json').version,
  production: true,
  test: false,
  local: false,
  disableGlobalErrorModal: false,
  logErrorToConsole: true,
};
